// Custom amenities (86bbrwd3v). Pure so they can be unit tested. Landlords type these next to
// the predefined checklist; the server applies the same rules, these just catch them early.
export const AMENITY_CATEGORIES = ['interior', 'exterior', 'community', 'optional']
export const MAX_CUSTOM_AMENITIES_PER_CATEGORY = 20
export const MAX_CUSTOM_AMENITY_NAME_LENGTH = 50

// Mirrors UpdatePropertyAmenitiesRequest::prepareForValidation(): invisible formatting
// characters (zero-width spaces and the like) removed, whitespace trimmed and collapsed.
export const cleanAmenityName = (name) => String(name ?? '')
    .replace(/\p{Cf}+/gu, '')
    .trim()
    .replace(/\s+/g, ' ')

// Mirrors UpdatePropertyAmenitiesRequest::comparableName(): case, accents, full-width letters
// and extra spaces ignored.
export const comparableAmenityName = (name) => {
    const cleaned = cleanAmenityName(name).normalize('NFKC').toLowerCase()
    const folded = cleaned.normalize('NFKD').replace(/\p{M}+/gu, '')

    return folded || cleaned
}

// Predefined amenities first, then custom ones, as one list of { key, name } chips.
export function mergedAmenities(property) {
    const predefined = (property?.amenities || []).map((amenity) => ({ key: `amenity-${amenity.id}`, name: amenity.name }))
    const custom = (property?.custom_amenities || []).map((amenity) => ({ key: `custom-${amenity.id}`, name: amenity.name }))

    return [...predefined, ...custom]
}

// Returns an error message, or null when `name` can be added to `category`.
export function customAmenityError(name, category, customAmenities, checklistOptions) {
    const cleaned = cleanAmenityName(name)
    const label = category.charAt(0).toUpperCase() + category.slice(1)

    if (!cleaned) {
        return 'Enter a name for the custom amenity.'
    }
    if (cleaned.length > MAX_CUSTOM_AMENITY_NAME_LENGTH) {
        return `Custom amenity names can be up to ${MAX_CUSTOM_AMENITY_NAME_LENGTH} characters.`
    }

    const comparable = comparableAmenityName(cleaned)
    const inCategory = customAmenities.filter((amenity) => amenity.category === category)

    if ((checklistOptions?.[category] || []).some((option) => comparableAmenityName(option.name) === comparable)) {
        return `"${cleaned}" is already in the ${label} checklist. Tick it instead.`
    }
    if (inCategory.some((amenity) => comparableAmenityName(amenity.name) === comparable)) {
        return `"${cleaned}" is already added to ${label}.`
    }
    if (inCategory.length >= MAX_CUSTOM_AMENITIES_PER_CATEGORY) {
        return `You can add up to ${MAX_CUSTOM_AMENITIES_PER_CATEGORY} custom amenities to ${label}.`
    }

    return null
}
